<template>
  <div>
    <!--弹出框-->
    <el-dialog title="请选择新增淤地坝类型" :visible.sync="dialogVisible" :modal="false" v-dialogDrag :before-close="handleClose"
      :close-on-click-modal="false" :show-close="true" :close-on-press-escape="false">
      <div class="xuanze">
        <el-button type="primary" @click="xzData('大型')">大型坝</el-button>
        <el-button type="primary" @click="xzData('中型')">中型坝</el-button>
        <el-button type="primary" @click="xzData('小型')">小型坝</el-button>
      </div>
    </el-dialog>
    <!--弹出框-->
  </div>
</template>

<script>
  export default {
    data() {
      return {
        dialogVisible: true, //弹出框显示
      }
    },
    components: {},
    mounted() {},
    methods: {
      xzData(type) {
        // this.dialogVisible = false;
        this.$emit("baxing", type);
      },
      handleClose(done) {
        this.dialogVisible = false;
        this.$emit("getcancel", {
          "dialogVisible": this.dialogVisible
        })
      },
    },
  };
</script>

<style scoped="scoped">
  >>>.el-dialog {
    width: 700px;
  }

  >>>.el-dialog__body {
    height: 200px;
    overflow: auto;
  }

  .xuanze {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    height: 100%;
  }

  >>>.el-button {
    padding: 12px 20px !important;
  }
</style>
